import { useRegisterAttributeLinks } from '@apps/card/ProductUIConfig/utils/state/state.mapping';
import { useStationeryProductPricingContext } from '@apps/card/ProductUIConfig/utils/useStationeryProductPricingContext';
import { GenericPriceSummary, PriceSummaryProps } from './GenericPriceSummary';
import React from 'react';
import { useProductPriceSummaryController } from './ProductPriceSummary.controller';
import LegacyPriceSummary from './LegacyPriceSummary';

const OrderProductPriceSummary: React.FC<PriceSummaryProps> = props => {
  const { priceUpTo, cardConfig, salesTax, promotion, attributes } = props;
  const { activeProduct, priceCalculator } = useStationeryProductPricingContext();

  const shouldShowShipping = priceUpTo === 'total';

  if (!attributes) {
    throw new Error('Tried rendering OrderProductPriceSummary with no attributes');
  }

  const summary = useProductPriceSummaryController(priceCalculator, cardConfig, activeProduct, attributes, shouldShowShipping, salesTax, promotion ?? undefined);

  return <GenericPriceSummary {...props} summary={summary} />;
};

const ProductPriceSummary: React.FC<PriceSummaryProps> = props => {
  const { priceUpTo, cardConfig, salesTax, promotion } = props;
  const { activeProduct, priceCalculator, attributeStates } = useStationeryProductPricingContext();
  useRegisterAttributeLinks(attributeStates.addAttribute, activeProduct);
  const { getFullState } = attributeStates;
  const options = getFullState(cardConfig);
  const shouldShowShipping = priceUpTo === 'total';

  const summary = useProductPriceSummaryController(priceCalculator, cardConfig, activeProduct, options, shouldShowShipping, salesTax, promotion ?? undefined);

  return <GenericPriceSummary {...props} summary={summary} />;
};

const PriceSummary: React.FC<PriceSummaryProps> = props => {
  const { products } = useStationeryProductPricingContext();
  const { attributes } = props;

  if (products.length > 0) {
    if (attributes) {
      if (attributes.length > 0) {
        return <OrderProductPriceSummary {...props} />;
      } else {
        return <LegacyPriceSummary {...props} />;
      }
    } else {
      return <ProductPriceSummary {...props} />;
    }
  } else {
    return <LegacyPriceSummary {...props} />;
  }
};

export default PriceSummary;
